import { Title, Subtitle, Bold, Body, Link } from '@panwds/react-ui'
import DividerLine from '../common/DividerLine'

import type { ComponentDef } from '../../renderer'
import { useMemo, type ReactElement } from 'react'
import type { CommonStoreState } from '../../store'
import { isDefaultTsgFeaturesEnabled } from '../common/utils'

export interface UAccordionProps {
  state: CommonStoreState
  title: string
  subtitle?: string
  link?: string
  componentKey?: string
  children: ComponentDef | ComponentDef[] | ReactElement | ReactElement[]
}
const UActivationSection = (props: UAccordionProps) => {
  const { title, subtitle, link, children, state, componentKey } = props
  const enableDefaultTsgFeatures = isDefaultTsgFeaturesEnabled(state)

  const activationTitle = useMemo(() => {
    let _title: string|undefined = ''
    if (enableDefaultTsgFeatures && componentKey === 'activation-section-csp') {
      const isSingleCSP = state.supportAccounts?.length === 1 && state.supportAccountId
      _title = isSingleCSP ? state.supportAccounts?.find(e => state.supportAccountId === String(e.accountid))?.name : ''
    }
    return _title ? `Customer Support Account: ${state.supportAccountId}-${_title}` : title
  },
  [componentKey, enableDefaultTsgFeatures, state.supportAccountId, state.supportAccounts, title])

  return (
    <div className='cm-justify-ceneter cm-mb-8'>
      <Title addClassName='cm-flex cm-capitalize' level={2} size={'sm'}>
        <Bold appearance='semibold'>{activationTitle}</Bold>
      </Title>
      {subtitle && <Subtitle>
        <Body addClassName='cm-pr-2' appearance='secondary' as='span'>{subtitle}</Body>
        {Boolean(link) && <Link href={link} external>Learn more</Link>}
      </Subtitle>}
      <DividerLine />
      <div>
        {children}
      </div>
    </div>
  )
}

export default UActivationSection
